<template>
  <div class="OnlineBookPage">
    <mu-container style="margin-top:10px;">
      <mu-form ref="BookInfo" :model="OnMod" label-position="right" class="mu-demo-form" label-width="80">
        <mu-form-item :rules="UserNoRules" prop="UserNo" label="工号: ">
          <mu-text-field v-model="OnMod.UserNo"/>
        </mu-form-item>
        <mu-form-item :rules="UserNameRules" prop="TrueName" label="姓名: ">
          <mu-text-field v-model="OnMod.TrueName"/>
        </mu-form-item>
        <mu-form-item :rules="MobileRules" prop="Mobile" label="电话: ">
          <mu-text-field v-model="OnMod.Mobile" type="number"/>
        </mu-form-item>
        <mu-form-item :rules="CompNameRules" prop="CompName" label="单位: ">
          <mu-text-field v-model="OnMod.CompName"/>
        </mu-form-item>
      </mu-form>
    </mu-container>

    <mu-container style="margin-bottom:10px;">
      <mu-button full-width color="primary" @click="Submit">提交</mu-button>
    </mu-container>
    <!-- <mu-container style="margin-bottom:34px;">
      <mu-button full-width @click="GoBack">返回</mu-button>
    </mu-container> -->

    <mu-container>
      <mu-dialog :open.sync="ShowDet" title="申请信息确认" width="360">
        <div>工号： {{ OnMod.UserNo }}</div>
        <div>姓名：{{ OnMod.TrueName }}</div>
        <div>联系电话：{{ OnMod.Mobile }}</div>
        <div>单位：{{ OnMod.CompName }}</div>
        <mu-button slot="actions" flat color="primary" @click="Book">确定</mu-button>
        <mu-button slot="actions" flat color="primary" @click="ShowDet = !ShowDet">返回修改</mu-button>
      </mu-dialog>
    </mu-container>
  </div>
</template>

<script>
import Toast from 'muse-ui-toast'
import { OnlineBook } from '../.././../api/all'
export default {
  name: 'OnlineBookPage',
  // props: {
  //   OnMod: {
  //     type: Object,
  //     default: function() {
  //       return {
  //         TrueName: '',
  //         Mobile: '',
  //         CompName: ''
  //       }
  //     }
  //   }
  // },
  props: {
    ModId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      MobileReg: /^[1][3,4,5,7,8,9][0-9]{9}$/,
      UserNoRules: [
        { validate: (val) => !!val, message: '必须填写工号' },
        { validate: (val) => val.length === 6, message: '工号错误' }
      ],
      UserNameRules: [
        { validate: (val) => !!val, message: '必须填写姓名' },
        { validate: (val) => val.length >= 2, message: '姓名需多于2个字' }
      ],
      MobileRules: [
        { validate: (val) => !!val, message: '必须填写联系电话' },
        { validate: (val) => this.MobileReg.test(val), message: '请填写正确格式的手机号码' }
      ],
      CompNameRules: [
        { validate: (val) => !!val, message: '必须填写单位' }
      ],
      ShowDet: false,
      OnMod: {
        UserNo: '',
        TrueName: '',
        Mobile: '',
        CompName: ''
      }
    }
  },
  methods: {
    Submit: function() {
      this.$refs.BookInfo.validate().then((result) => {
        if (result) {
          this.ShowDet = true
        }
      })
    },
    Book: function() {
      var WxUserId = this.$store.getters.wxuserid
      OnlineBook(this.OnMod.Id, this.OnMod.TrueName, this.OnMod.Mobile, this.OnMod.CompName, WxUserId, this.OnMod.UserNo).then(res => {
        console.log(res)
        if (res.error === 0) {
          Toast.success('申请成功！请耐心等待审核结果！')
          this.$emit('ApplySuccess')
        }
        if (res.error === 1) {
          Toast.error(res.msg)
          this.$emit('ApplySuccess')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/OnLineBook/components/BookPage.vue